import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import LoadingOverlay from "../../components/LoadingOverlay";

const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate(); // useNavigate追加

  const handleSendEmail = async (event: React.FormEvent) => {
    event.preventDefault();

    try {
      setIsLoading(true);
      interface ForgotPasswordResponse {
        message?: string;
        error?: string;
      }
      const response = await axios.post<ForgotPasswordResponse>(
        `${process.env.REACT_APP_BACKEND_URL}/api/forgot-password`,
        { email },
        { withCredentials: true }
      );
      setMessage(response.data.message || "メールを送信しました。");
    } catch (error: any) {
      setMessage(
        error.response?.data?.error ||
          "エラーが発生しました。もう一度お試しください。"
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100">
      {isLoading && <LoadingOverlay />}
      <div className="w-full max-w-md bg-white p-8 rounded-lg shadow-lg">
        <div className="flex justify-center mb-6">
          <img src="/isopra_icon.png" alt="Logo" className="w-20 h-20" />
        </div>
        <h2 className="text-2xl font-bold text-center text-gray-700 mb-4">
          パスワード再設定
        </h2>
        <p className="text-gray-600 text-center mb-6">
          登録されているメールアドレスに再設定用リンクを送信します。
        </p>
        <form onSubmit={handleSendEmail} className="space-y-4">
          <div>
            <label className="block text-gray-700">メールアドレス</label>
            <input
              type="email"
              name="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="example@example.com"
            />
          </div>
          <button
            type="submit"
            className="w-full bg-iso text-white font-bold py-2 rounded-lg hover:bg-opacity-50"
          >
            メール送信
          </button>
        </form>
        {message && <p className="mt-4 text-center text-red-500">{message}</p>}

        {/* ログインに戻るボタン */}
        <div className="mt-4 text-center">
          <span
            onClick={() => navigate("/login")}
            className="text-blue-500 cursor-pointer hover:underline"
          >
            ログイン画面に戻る
          </span>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
